import { Box } from '@mui/material'
import { Button } from '../../../components/buttons'
import { colorPalette } from '../../../style/colorPalette'
import ReloadIcon from '../../../components/icons/ReloadIcon'
import TermSelector, {
  DisplayUnit,
  ShiftType,
} from '../../../containers/BulkSheetView/components/header/datePicker/TermSelector'
import FilterButton from '../../../containers/BulkSheetView/components/header/FilterButton'
import SortButton from '../../../containers/BulkSheetView/components/header/SortButton'
import ColumnSettingButton from '../../../containers/BulkSheetView/components/header/ColumnSettingButton'
import DisplayFormatButton from '../../../containers/BulkSheetView/components/header/DisplayFormatButton'
import { DateTerm } from '../../../../utils/date'
import { ColDef } from 'ag-grid-community'
import { TaskActualWorkProxyRegistrationRow } from '../taskActualWorkProxyRegistration'
import { SortedColumnState } from '../../../model/bulkSheetColumnSortState'
import styled from 'styled-components'
import { DecimalAndSexagesimalScale } from '../../../../lib/functions/decimalAndSexagesimalScale'
import { DecimalAndSexagesimalScaleToggleButtonGroup } from '../../../components/inputs/ToggleButtonGroup/DecimalAndSexagesimalScaleToggleGroup'

type Props = {
  onReload: () => Promise<void>
  displayUnit: DisplayUnit
  dateTerm: DateTerm | undefined
  onChangeTerm: (displayUnit: DisplayUnit) => void
  shiftDisplayTerm: (shiftType: ShiftType, unit?: DisplayUnit) => void
  filteredColumns: ColDef<any>[]
  onDeleteFilteredColumn: (column: ColDef<any>) => void
  resetFilters: () => void
  onDeleteSortedColumn: (
    colId: string | ColDef<TaskActualWorkProxyRegistrationRow>
  ) => void
  onDeleteSortedAllColumns: () => void
  onChangeSortColumnState: (
    colId: string | ColDef<TaskActualWorkProxyRegistrationRow>,
    sort: 'asc' | 'desc' | null
  ) => void
  sortColumnsState: SortedColumnState[]
  onClickColumnSettingButton: (e) => void
  columnSettingOpen: boolean
  rowHeight: number
  onChangeRowHeight: (value: number) => void
  dateFormat: string
  onChangeDateFormat: (value: string) => void
  decimalAndSexagesimalScale: DecimalAndSexagesimalScale
  onChangeDecimalAndSexagesimalScale: (
    value: DecimalAndSexagesimalScale
  ) => void
}

export const TaskActualWorkProxyRegistrationHeader = ({
  onReload,
  displayUnit,
  dateTerm,
  onChangeTerm,
  shiftDisplayTerm,
  filteredColumns,
  onDeleteFilteredColumn,
  resetFilters,
  onDeleteSortedColumn,
  onDeleteSortedAllColumns,
  onChangeSortColumnState,
  sortColumnsState,
  onClickColumnSettingButton,
  columnSettingOpen,
  rowHeight,
  onChangeRowHeight,
  dateFormat,
  onChangeDateFormat,
  decimalAndSexagesimalScale,
  onChangeDecimalAndSexagesimalScale,
}: Props) => {
  return (
    <TaskActualWorkProxyRegistrationHeaderBox>
      <ReloadButton onClick={onReload}>
        <ReloadIcon />
      </ReloadButton>
      <TermSelector
        displayUnit={displayUnit}
        dateTerm={dateTerm}
        onChangeTerm={onChangeTerm}
        shiftDisplayTerm={shiftDisplayTerm}
      />
      <DecimalAndSexagesimalScaleToggleButtonGroup
        value={decimalAndSexagesimalScale}
        onChange={onChangeDecimalAndSexagesimalScale}
      />
      <FilterButton
        filteredColumns={filteredColumns}
        onDeleteFilteredColumn={onDeleteFilteredColumn}
        resetFilters={resetFilters}
      />
      <SortButton
        onDeleteSortedColumn={onDeleteSortedColumn}
        onDeleteSortedAllColumns={onDeleteSortedAllColumns}
        onChangeSortColumnState={onChangeSortColumnState}
        sortColumnsState={sortColumnsState}
      />
      <ColumnSettingButton
        onClick={onClickColumnSettingButton}
        open={columnSettingOpen}
      />
      <DisplayFormatButton
        height={rowHeight}
        onChangeHeight={onChangeRowHeight}
        currentFormat={dateFormat}
        onChangeDateFormat={onChangeDateFormat}
      />
    </TaskActualWorkProxyRegistrationHeaderBox>
  )
}

const TaskActualWorkProxyRegistrationHeaderBox = styled(Box)({
  width: 'fit-content',
  height: '60px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 20px 10px 20px',
})

const ReloadButton = styled(Button)({
  background: colorPalette.monotone[1],
  border: `1px solid ${colorPalette.monotone[3]}`,
  borderRadius: '50%',
  height: '28px',
  width: '28px',
  marginRight: '10px',
  padding: '5px 8px',
  cursor: 'pointer',
  '&:hover': { background: colorPalette.monotone[1] },
})
